import { AppElement, AppFC } from '../../../interfaces';

export const ExclamationIcon: AppFC = (props): AppElement => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.0001 8.99993V12.7499M2.69707 16.1259C1.83107 17.6259 2.91407 19.4999 4.64507 19.4999H19.3551C21.0851 19.4999 22.1681 17.6259 21.3031 16.1259L13.9491 3.37793C13.0831 1.87793 10.9171 1.87793 10.0511 3.37793L2.69707 16.1259ZM12.0001 15.7499H12.0071V15.7579H12.0001V15.7499Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
